<template>
    <InformeCard title="Liberacion de butacas" collapsable="true" id="liberacion_butacas" name="liberacion_butacas">
        <ContentOrLoading>
            <div class="table-responsive">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>Asientos Liberados</th>
                            <th>Asientos Comprados</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ liberados }}</td>
                            <td>{{ comprados }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ContentOrLoading>
    </InformeCard>
</template>

<script>
import ContentOrLoading from "../../components/ContentOrLoading";
import InformeCard from "../InformeCard";
export default {
    props: ['event_id'],
    data() {
        return {
            liberados : null,
            comprados : null
        }
    },
    created(){
        this.getAsientosLiberados();
    },
    methods : {
        getAsientosLiberados(){
            const params = {
                filters : {},
                evento_id : this.event_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.informe.asientos.liberados'), params).then(res => {
                this.liberados = res.data.liberados;
                this.comprados = res.data.comprados;
            });
        }
    },
    components: {
        InformeCard,
        ContentOrLoading
    }
}
</script>